import styled from 'styled-components';

export const Container = styled.div`

  > h1 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

`;

export const HeaderSection = styled.section`
  display: flex;
  flex-direction: row;
  margin-bottom: 2rem;
  justify-content: space-between;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  width: 100%;

  > svg {
    margin-left: 1.5rem;
    position: absolute;
    color: ${props => props.theme.colors.muted}80;
    font-size: 20px;
  }

  > input {
    padding: 1rem 2.5rem 1rem 3.5rem;
    background: ${props => props.theme.cards.primary};
    border: 1px solid ${props => props.theme.cards.border};
    box-shadow: ${props => props.theme.shadows.primary};
    border-radius: 50px;
    color: ${props => props.theme.colors.white};
    width: 100%;
    width: 100%;
    transition: all .3s ease-in-out;

    &::placeholder {
      color: ${props => props.theme.colors.muted};
    }
  }
`;

export const SectionContainer1 = styled.section`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1.5rem;
  box-sizing: border-box;
  transition: all .3s ease-in-out;

  &:hover {

    > :not(:hover) {
      opacity: 1;
      //filter: blur(1px) brightness(.99);
    }
  }

  /* DESKTOP */
  @media (max-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
  }

  /* TABLET */
  @media (max-width: 960px) {
    grid-template-columns: repeat(3, 1fr);
  }

  /* TABLET MINI */
  @media (max-width: 830px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* MOBILE */
  @media (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
  }

  > a {
    
    > div {
      border-radius: 0;
      border: none;
    }
  }
`;